import * as React from 'react';
import { Button, Col, Form, Modal, Row, Select, Input, Typography, Space } from 'antd';
import { Formik, FormikProps } from "formik";
import { useRef, useState } from 'react';
import * as Yup from 'yup';
import { CompanyUserProfile } from '../../../models/company-user-profile-interface';
import { CustomerServiceQueries } from '../../../queries/customer-service-queries';
import { UserTypeUpdate } from '../../../models/user-profile-type-interface';

const { Option } = Select;
const { TextArea } = Input;
const { Title } = Typography;

type Props = {
  isVisible: boolean,
  setIsVisible: React.Dispatch<React.SetStateAction<boolean>>,
  profile: CompanyUserProfile
}

const ChangeUserTypeModal: React.FC<Props> = ({
  isVisible,
  setIsVisible,
  profile
}) => {
  const usePutUserType = CustomerServiceQueries.usePutUserType(profile?.userId);
  const formRef = useRef<FormikProps<any>>(null);

  return (
    <Modal
      centered
      title="Change User Type"
      visible={isVisible}
      onCancel={() => setIsVisible(false)}
      footer={null}
      destroyOnClose
    >
      <Formik
        innerRef={formRef}
        initialValues={{
          selectedRoleId: profile.roleId,
          reason: ""
        }}
        validationSchema={
          Yup.object().shape({
            reason: Yup.string().required('Please input a reason for this change')
          })
        }
        onSubmit={(values) => {
          const data: UserTypeUpdate = {
            userId: profile?.userId,
            companyId: profile?.companyId,
            reason: values.reason,
            newRoleId: values.selectedRoleId
          };
          usePutUserType.mutateAsync(data).then(() => {
            profile.roleId = values.selectedRoleId;
            setIsVisible(false);
          });
        }}
        enableReinitialize
      >
        {({
            values,
            errors,
            touched,
            setFieldValue,
            resetForm,
            handleChange,
            handleBlur,
            handleSubmit
        }) => (
          <Form layout="vertical" name='userTypeForm' onFinish={handleSubmit}>
            <Title level={5}>
              {profile?.companyName}
            </Title>
            <Row gutter={[16, 16]}>
              <Col span={24}>
                <Select
                  style={{ minWidth: 200 }}
                  value={values.selectedRoleId}
                  onSelect={(val) => setFieldValue('selectedRoleId', val)}
                >
                  <Option value={1} key={1}>
                    Standard User
                  </Option>
                  <Option value={2} key={2}>
                    Super User
                  </Option>
                  <Option value={3} key={3}>
                    Admin
                  </Option>
                </Select>
              </Col>
              <Col span={24}>
                <Form.Item 
                  label="Reason"
                  help={(touched.reason && errors.reason ? errors.reason : null)}
                  validateStatus={touched.reason && errors.reason ? 'error' : ''}
                  required
                >
                  <TextArea
                    rows={4}
                    value={values.reason}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    name='reason'
                  />
                </Form.Item>
              </Col>
              <Col flex="auto" />
              <Col>
                <Space>
                  <Button
                    onClick={() => {
                      resetForm();
                      setIsVisible(false);
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    type="primary"
                    disabled={values?.selectedRoleId == profile.roleId || errors?.reason}
                    htmlType='submit'
                    form="userTypeForm"
                    loading={usePutUserType.isLoading}
                  >
                    Save
                  </Button>
                </Space>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </Modal>
  )
};

export default ChangeUserTypeModal;